export default __webpack_public_path__ + "static/media/UBTECH.efde0872.svg";